export default "__VITE_ASSET__BKcN0SsM__"